export default __webpack_public_path__ + "cb733f1af70ae1ea740cfd1471557146.png";